import axios from 'axios';

import StorageService from './storage-service';
import AuthService from './auth-service';

import { API_URL } from 'utilities/constants';
const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const authToken = StorageService.getItem('authToken');
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    // Handle token expiration and refresh token
    if (error.response?.status && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshTokenSuccess = await AuthService.refreshToken();
      if (refreshTokenSuccess) {
        originalRequest.headers.Authorization = `Bearer ${StorageService.getItem('authToken')}`;
        return axiosInstance(originalRequest);
      } else {
        window.location.href = '/app/login';
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
